/**
 * Hawkin L/R fields use formula (Left − Right) / (Left + Right) × 100.
 * Positive = left-dominant, negative = right-dominant.
 */
export function formatLrAsymmetryPct(value: number): string {
    const mag = Math.abs(value);
    const s = mag.toFixed(1);
    if (value > 0) return `${s}% L`;
    if (value < 0) return `${s}% R`;
    return `${s}%`;
}

export const LR_ASYMMETRY_METRIC_KEYS = [
    'lr_avg_propulsive_force_pct',
    'lr_avg_braking_force_pct',
] as const;

export function isLrAsymmetryMetricKey(key: string): boolean {
    return (LR_ASYMMETRY_METRIC_KEYS as readonly string[]).includes(key);
}
